import React, { useState, useEffect } from "react";
import { useHttpClient } from "../../../../shared/hooks/http-hook";
import FiltrosRelatorio from "../ui/filtrosRelatorio/FiltrosRelatorio";
import RelatorioFaltas from "./components/RelatorioFaltas";
import RelatorioFaltasAgendaTratamento from "./components/RelatorioFaltasAgendaTratamento";
import RelatorioUrgencias from "./components/RelatorioUrgencias";
import "./RelatoriosAgendamentos.scss";

const tiposRelatorios = [
  { value: "", label: "Selecione um relatório" },
  { value: "faltas", label: "Relatório de Faltas" },
  { value: "urgencias", label: "Relatório de Urgências" },
  // Adicione mais tipos de relatórios de agendamento conforme necessário
];

// Definição de quais relatórios suportam quais ações
const relatorioCaps = {
  faltas: { gerar: true, exportar: true },
  urgencias: { gerar: true, exportar: true },
  // Configure as capacidades para outros relatórios aqui
};

function RelatoriosAgendamentos({ auth, clinica }) {
  const { sendRequest } = useHttpClient();
  const [dadosRelatorio, setDadosRelatorio] = useState({
    open: "",
    dataFiltro: {},
    acao: "",
    //Contador para forçar a atualização
    atualizacoes: 0,
  });

  // Unidades da clínica e a escolhida. Vazio = consolidado da empresa; em
  // clínicas de unidade única a lista fica vazia e o seletor nem aparece.
  const [unidades, setUnidades] = useState([]);
  const [unidadeSelecionada, setUnidadeSelecionada] = useState("");

  useEffect(() => {
    // Só faz sentido oferecer a escolha quando a clínica tem mesmo mais do que
    // uma unidade — nas outras nem se pede a lista.
    if (!clinica?.clinica?.multiEstabelecimento) return;

    const fetchUnidades = async () => {
      try {
        const resposta = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/estabelecimentos/clinica/${clinica.clinica._id}`,
          "GET",
          null,
          { Authorization: "Bearer " + auth.token },
        );
        setUnidades(resposta.estabelecimentos || []);
      } catch (err) {
        console.error("err", err);
      }
    };
    fetchUnidades();
  }, [
    sendRequest,
    auth.token,
    clinica?.clinica?._id,
    clinica?.clinica?.multiEstabelecimento,
  ]);

  const gerarRelatorioHandler = (dataInicial, dataFinal, tipoRelatorio) => {
    if (!tipoRelatorio) {
      // Alerta se nenhum tipo de relatório for selecionado
      return;
    }

    setDadosRelatorio((prevState) => ({
      open: tipoRelatorio,
      dataFiltro: { dataInicial: dataInicial, dataFinal: dataFinal },
      acao: "gerar",
      atualizacoes: prevState.atualizacoes + 1,
    }));
  };

  const exportarFicheiroHandler = (dataInicial, dataFinal, tipoRelatorio) => {
    if (!tipoRelatorio) {
      // Alerta se nenhum tipo de relatório for selecionado
      return;
    }

    setDadosRelatorio((prevState) => ({
      open: tipoRelatorio,
      dataFiltro: { dataInicial: dataInicial, dataFinal: dataFinal },
      acao: "exportar",
      atualizacoes: prevState.atualizacoes + 1,
    }));
  };

  // Função auxiliar para renderizar o componente de relatório correto
  const renderizarRelatorio = () => {
    const { open, dataFiltro, acao, atualizacoes } = dadosRelatorio;

    if (!open) return null;

    const props = {
      dataFiltro: dataFiltro,
      clinicaId: clinica.clinica._id,
      auth: auth,
      acao: acao,
      sendRequest: sendRequest,
      atualizacoes: atualizacoes,
      // Unidade escolhida (vazio = consolidado) e a lista, para o relatório
      // pedir os dados dessa unidade e rotular a análise por balcão.
      unidadeSelecionada: unidadeSelecionada,
      unidades: unidades,
    };

    switch (open) {
      case "faltas":
        if (
          clinica?.clinica?.configuracoes?.configuracoes?.tipoAgendamento
            ?.tipo === "Tratamento"
        ) {
          return <RelatorioFaltasAgendaTratamento {...props} />;
        } else {
          return <RelatorioFaltas {...props} />;
        }
      case "urgencias":
        return <RelatorioUrgencias {...props} />;
      default:
        return null;
    }
  };

  return (
    <div>
      <FiltrosRelatorio
        tiposRelatorios={tiposRelatorios}
        gerarRelatorioHandler={gerarRelatorioHandler}
        exportarFicheiroHandler={exportarFicheiroHandler}
        relatorioCaps={relatorioCaps}
        // Manter o tipo de relatório selecionado
        relatorioSelecionado={dadosRelatorio.open}
        unidades={unidades}
        unidadeSelecionada={unidadeSelecionada}
        onUnidadeChange={setUnidadeSelecionada}
        relatoriosComUnidade={["faltas", "urgencias"]}
      />

      {renderizarRelatorio()}
    </div>
  );
}

export default RelatoriosAgendamentos;
